/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect, useState } from 'react';
import { RetentionCohortsType } from './analytics';
import { Moment } from 'moment';

type weekType = {
	time: string;
	size: number;
	weeks: number[];
};

const CohortsView = ({
	cohorts,
	endDate
}: {
	cohorts: RetentionCohortsType[];
	endDate: Moment;
}) => {
	const [tableData, setTableData] = useState<weekType[]>([]);
	const [isPercentage, setIsPercentage] = useState(true);
	// const [weekCount, setWeekCount] = useState(0);

	useEffect(() => {
		const updatedTable: any[] = [];
		cohorts.forEach((item, index) => {
			const weeks = isPercentage
				? item.retentionData.map((week) =>
						Math.floor((week / item.total) * 100)
				  )
				: item.retentionData;
			updatedTable.push({
				weeks: weeks,
				size: item.total,
				time: `${endDate
					.clone()
					.subtract(cohorts.length - index, 'weeks')
					.startOf('week')
					.format('MM/DD')} - ${endDate
					.clone()
					.subtract(cohorts.length - index - 1, 'weeks')
					.startOf('week')
					.format('MM/DD')}`
			});
		});
		setTableData(updatedTable);
	}, [isPercentage]);

	return (
		<div className="flex w-full flex-col items-end">
			<div className="inline-flex rounded-md shadow-sm" role="group">
				<div
					className={`py-2 px-4 text-sm font-medium text-gray-900 rounded-l-lg border border-gray-900 dark:border-white transition-all duration-500 cursor-pointer
										${
											isPercentage
												? 'bg-purple-500 text-white hover:bg-purple-600'
												: 'dark:hover:bg-purple-400 hover:bg-gray-700 hover:text-white dark:text-white dark:hover:text-white'
										}`}
					onClick={() => setIsPercentage(true)}
				>
					<input
						type="radio"
						name="percentage"
						id="percentage"
						checked={isPercentage}
						hidden
					/>
					<label className=" cursor-pointer" htmlFor="percentage">
						Percentage
					</label>
				</div>

				<div
					className={`py-2 px-4 text-sm font-medium text-gray-900 border-t border-b border-r rounded-r-lg border-gray-900 dark:border-white transition-all duration-500 cursor-pointer
										${
											!isPercentage
												? 'bg-purple-500 text-white hover:bg-purple-600'
												: 'dark:hover:bg-purple-400 hover:bg-gray-700 hover:text-white dark:text-white dark:hover:text-white'
										}`}
					onClick={() => setIsPercentage(false)}
				>
					<input
						type="radio"
						name="number"
						id="number"
						checked={!isPercentage}
						hidden
					/>
					<label className=" cursor-pointer" htmlFor="number">
						Count value
					</label>
				</div>
			</div>
			<table className="w-full table-auto">
				<thead>
					<tr>
						<th className="px-4 py-2 w-30 text-sm dark:text-gray-100">
							Cohort
						</th>
						<th className="px-4 w-10 py-2 text-sm dark:text-gray-100">Size</th>

						{Array.from(
							{ length: cohorts[0].retentionData.length },
							(_, i) => i
						).map((week) => (
							<th
								key={week}
								className="px-4 min-w-[90px] py-2 text-sm dark:text-gray-100"
							>
								{`Week ${week}`}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{tableData.map((row, index) => (
						<tr key={index}>
							<td className=" px-2 ml-5 h-10 min-w-[120px] text-gray-700 dark:text-gray-400 text-center font-medium">
								{row.time}
							</td>
							<td className=" px-4 h-10 text-gray-700 dark:text-gray-400 text-center font-medium">
								{row.size}
							</td>
							{row.weeks.map((week, weekIndex) => (
								<td key={weekIndex} className="h-10 items-center px-3 py-1">
									<TableItem value={week} isPercentage={isPercentage} />
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

const TableItem = ({
	value,
	isPercentage
}: {
	value: number;
	isPercentage: boolean;
}) => {
	return (
		<div
			className={`flex rounded-xl py-2 justify-center cursor-pointer hover:bg-purple-800 transition-all duration-300 
			hover:scale-105 ${
				value >= 60
					? 'bg-purple-700'
					: value < 60 && value > 50
					? 'bg-purple-400'
					: 'bg-purple-400'
			}`}
		>
			<span
				className={`text-sm ${
					value > 40 ? 'text-white' : 'text-black'
				} font-semibold`}
			>{`${value}${isPercentage ? '%' : ''}`}</span>
		</div>
	);
};

export default CohortsView;
